const isObject = obj =>
    Object.prototype.toString.call(obj) === '[object Object]';

const isNumeric = str => {
    // check if a string is numeric
    if (typeof str != 'string') return false;
    return !isNaN(str) && !isNaN(parseFloat(str));
};

const objectToArray = object => {
    return Object.keys(object).map(key => {
        return {
            key,
            value: object[key],
        };
    });
};

const getObjectPaths = payload => {
    let working = [];

    if (isObject(payload)) {
        for (const [key, value] of Object.entries(payload)) {
            if (Array.isArray(value)) {
                value.forEach((item, index) => {
                    working.push(
                        ...getObjectPaths(value[index]).map(
                            subKey => `${key}[${index}].${subKey}`
                        )
                    );
                });
            } else if (isObject(value)) {
                working.push(
                    ...getObjectPaths(value).map(subKey => `${key}.${subKey}`)
                );
            } else {
                working.push(key);
            }
        }
    }
    return working;
};

const deepFormTransform = object => {
    const newObj = {};
    if (isObject(object)) {
        Object.keys(object).forEach(key => {
            if (isObject(object[key])) {
                newObj[key] = deepFormTransform(object[key]);
            } else {
                newObj[key] =
                    object[key] === true
                        ? 'true'
                        : object[key] === false
                        ? 'false'
                        : [
                              'imo_number',
                              'mmsi',
                              'reference_number',
                              'width_tonnage',
                              'depth_tonnage',
                              'tonnage',
                          ].includes(key)
                        ? object[key] === 0
                            ? ''
                            : object[key]
                        : key === 'year_month_days_input_json'
                        ? JSON.parse(object[key].replaceAll("'", '"'))
                        : object[key];
            }
        });
        return newObj;
    } else {
        return null;
    }
};

const isJSON = str => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export {
    isObject,
    isNumeric,
    objectToArray,
    getObjectPaths,
    deepFormTransform,
    isJSON,
};
